export const environment = {
  production: true,
  baseUrl:'/api',
  versionCheckURL : '/version.json'
};
